import React,{useState,useImperativeHandle,forwardRef,useEffect} from 'react'
import { Modal,message,Pagination,Empty,Input,Table,Button } from 'antd';
import { activityCycleProduct,reissue } from '@/services/afterSales';
import { ResDataType } from "@/services/ajax";
import usePagAndCommon from '@/hooks/usePagAndCommon';
import { cycleProductDataType,column } from './column';
import { ExpandedDataType,DataType } from '../../column';
import type { TableProps } from 'antd';
type TableRowSelection<T extends object = object> = TableProps<T>['rowSelection'];

 const CycleProductList = (props:{ save: (selectedPr: DataType) => void },ref:any) => {
    const { save } = props;
    const [data,setData] = useState<cycleProductDataType[]>([]);
    const [searchData,setSearchData] = useState<cycleProductDataType[]>([]);
    const [name,setName] = useState('');
    const [accountModal, setAccountModal] = useState(false);
    const [collectionAccounts, setCollectionAccounts] = useState('');
    const [selectedRowKeys, setSelectedRowKeys] = useState<cycleProductDataType[]>([]);
    const [curRecord,setCurRecord] = useState<ExpandedDataType>();
    const [selectedPr,setSelectedPr] = useState<DataType>();
    const { page,setPage,pageSize,total,setTotal,flag,setFlag,isModalOpen, setIsModalOpen } = usePagAndCommon();
    const showModal = (row:ExpandedDataType,selectPriv: DataType) => {
        setName('');
        setData([]);
        setCurRecord(row);
        setSelectedPr(selectPriv);
        setIsModalOpen(true);
        fetchData(row);
    };
    
    const handleCancel = () => {
      setSelectedRowKeys([]);
      setIsModalOpen(false);
    };

    const onSelectChange = (newSelectedRowKeys: React.Key[],selectedRows:cycleProductDataType[]) => {
        setSelectedRowKeys(selectedRows);
    };

    const rowSelection: TableRowSelection<cycleProductDataType> = {
        selectedRowKeys:selectedRowKeys.map((row:cycleProductDataType) => row.productId),
        onChange: onSelectChange,
        type: 'radio'
    };

    const fetchData = async (row: ExpandedDataType) => {
        setFlag(true)
        const { userActivityCycleId, activityCycleId } = row || {}
        const res = await activityCycleProduct(userActivityCycleId,activityCycleId) as ResDataType;
        if (res.code!= 0) {
          message.error(res.message);
          return;
        } 
        setData(res.data.list);
        setSearchData(res.data.list);
        setTotal(res.data.total);
        setFlag(false)
    }
    
    useImperativeHandle(ref, () => ({
        open: (row:ExpandedDataType, selectPriv: DataType) => showModal(row,selectPriv),
    }))

    useEffect(()=> {
        (curRecord && curRecord.userActivityCycleId ) && fetchData(curRecord as ExpandedDataType); 
    },[page])

    useEffect(()=> {
        searchProduct(name);
    },[name])

    const ModalOk = () => {
        setCollectionAccounts('');
        selectedRowKeys[0]?.accountType != '手机号' ? setAccountModal(true) : handleOk();
    }
    const handleOk = async() => {
        if (!collectionAccounts && selectedRowKeys[0]?.accountType != '手机号') {
            message.error('请输入对应账号');
            return; 
        }
        if (selectedRowKeys.length == 0) {
            message.error('请选择权益')
            return;
        }
        const data = {
            userActivityId: selectedRowKeys[0].userActivityId,
            activityId: selectedRowKeys[0].activityId,
            activityCycleId: selectedRowKeys[0].activityCycleId,
            userActivityCycleId: selectedRowKeys[0].userActivityCycleId,
            productId: selectedRowKeys[0].productId,
            activityCycleProductId: selectedRowKeys[0].activityCycleProductId,
            collectionAccount: collectionAccounts,
        }
        const res = await reissue(data) as ResDataType;
        if (res.code == 0) {
            selectedPr && save(selectedPr);
            setSelectedRowKeys([]);
            setCollectionAccounts('');
            setAccountModal(false); 
            setTimeout(()=>{
                setIsModalOpen(false); 
            },0)
            message.success('补发成功');
        } else {
            message.error(res.message);
        }
    };

    const searchProduct = (value:string) => {
        const newData = searchData.filter((item:cycleProductDataType) => item.productName.indexOf(value) != -1);
        setData(value ? newData : searchData);
    }

    return(
        <Modal maskClosable={false} width={800} title="选择权益" open={isModalOpen} okText='确定' cancelText="取消" onOk={ModalOk} onCancel={handleCancel}>
            <Input style={{ width:'50%',marginBottom:'10px' }} placeholder='权益名称' value={name} allowClear onChange={(e)=> {
                setName(e.target.value);
            } } />
            <div style={{height:'50vh',overflow:'auto'}}>
                <Table<cycleProductDataType>
                rowKey='productId'
                pagination={false}
                loading={flag}
                scroll={{ x: 'max-content', y: 380 }}
                locale={{ emptyText: <Empty description="暂无数据"></Empty> }}
                rowSelection={rowSelection} columns={column} dataSource={data} />
            </div>
            
            <Pagination align="center" showSizeChanger={false} defaultCurrent={page} current={page} pageSize={pageSize} total={total} onChange={(e)=>{ setPage(e); }} />
            <Modal open={accountModal} maskClosable={false} title='请填写要补发的对应账号' okText='确定' cancelText="取消" onOk={handleOk} onCancel={()=> setAccountModal(false)}>
                <div>
                    <span>{selectedRowKeys[0]?.accountType}：</span><Input placeholder={`请输入${selectedRowKeys[0]?.accountType}`} value={collectionAccounts} onChange={(e)=> setCollectionAccounts(e.target.value)} />
                </div>
            </Modal>
        </Modal>
    )
}

export default forwardRef(CycleProductList)